<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 id="_idParaDest-4" title="Contents"><span class="pagebreak" id="page7" title="7"></span></h1>
<h2 id="_idParaDest-5">Contents</h2>
<div>
<div id="_idContainer005">
<p class="firstleft"><a href="#/Text/pre#_idTextAnchor002">Preface</a></p>
<p class="firstleft"><a href="#/Text/intro#_idTextAnchor011">Introduction</a></p>
<p class="firstleft"><a href="#/Text/pt1#_idTextAnchor041"><b>PART ONE</b></a></p>
<p class="body"><a href="#/Text/pt1#_idTextAnchor041"><b><i>Why Study Philosophy?</i></b></a></p>
<blockquote>
<p class="firstleft"><a href="#/Text/ch1#_idParaDest-14">1. Philosophy and Baking Bread</a></p>
<p class="firstleft"><span href="#/Text/ch2#_idParaDest-16" title="Link target outside of Sample">2. Philosophy as Loving Wisdom</span></p>
<p class="firstleft"><span href="#/Text/ch3#_idParaDest-18" title="Link target outside of Sample">3. Faith, Philosophy and Scripture</span></p>
<p class="firstleft"><span href="#/Text/ch4#_idParaDest-20" title="Link target outside of Sample">4. Thinking About God</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/pt2#_idParaDest-21" title="Link target outside of Sample"><b>PART TWO</b></span></p>
<p class="body"><span href="#/Text/pt2#_idParaDest-23" title="Link target outside of Sample"><b><i>How To Study Philosophy</i></b></span></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch5#_idParaDest-25" title="Link target outside of Sample">5. Virtuous Philosophy</span></p>
<p class="firstleft"><span href="#/Text/ch6#_idParaDest-28" title="Link target outside of Sample">6. Philosophy and Community</span></p>
<p class="firstleft"><span href="#/Text/ch7#_idParaDest-30" title="Link target outside of Sample">7. Doubting Wisely</span></p>
<p class="firstleft"><span href="#/Text/ch8#_idParaDest-32" title="Link target outside of Sample">8. Pursuing Philosophy?</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/notes#_idParaDest-61" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/nameindex#_idParaDest-34" title="Link target outside of Sample">Name and Subject Index</span></p>
<p class="firstleft"><span href="#/Text/scriptureindex#_idParaDest-36" title="Link target outside of Sample">Scripture Index</span></p>
<p class="firstleft"><span href="#/Text/praise#_idParaDest-38" title="Link target outside of Sample">Praise for <i>A Little Book for New Philosophers</i></span></p>
<p class="firstleft"><span href="#/Text/ata#_idParaDest-40" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/moreivp#_idParaDest-42" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="firstleft"><span href="#/Text/rights#_idParaDest-2" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
<p class="body"><span class="pagebreak" id="page8" title="8"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6d287232